import GenericButton from "components/GenericButton/GenericButton"
import styled from "styled-components"
import { useCreateAiContext } from "./CreateAiContext"

const StyledBottomNavigation = styled.div`
  height: 70px;
  padding: 10px;
  justify-content: center;
  background-color: ${(p) => p.theme.colors.white};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.04);
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
  right: 0;

  ${({ theme }) => theme.breakpoints.up("md")} {
    position: relative;
    width: 300px;
    background-color: none;
    box-shadow: none;
  }
`

const CreatePictureAiButton = ({
  text,
  enabledButton,
  submit,
}: {
  text: string

  enabledButton: boolean
  submit: () => void
}) => {
  const { stylesData, propertiesData, backgroundsData } = useCreateAiContext()

  return (
    <StyledBottomNavigation>
      <GenericButton
        btnType="filled"
        disabled={
          !enabledButton
            ? !(stylesData && propertiesData.length > 0 && backgroundsData)
            : false
        }
        onClick={() => {
          submit()
        }}
      >
        {text}
      </GenericButton>
    </StyledBottomNavigation>
  )
}

export default CreatePictureAiButton
